var styles = {"tabs__list":"Steps_tabs__list_1j22v_1","active":"Steps_active_1j22v_30","tabs__tab":"Steps_tabs__tab_1j22v_39"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
